import gql from 'graphql-tag';

export const mutation = gql`
  mutation RemoveApplicationNote($prospectId: ID!, $noteId: ID!) {
    removeApplicationNote(input: { prospectId: $prospectId, noteId: $noteId }) {
      id
    }
  }
`;
